if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.submitButton = this.querySelector('[type="submit"]');

        if (this.submitButton) {
          this.submitButtonText =
            this.submitButton.querySelector('span');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.form || !this.submitButton) return;

        if (
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())

          .then((response) => {
            /*
            --------------------------------
            ERROR ADDING PRODUCT TO CART
            --------------------------------
            */

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors:
                  response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(
                response.description || response.message
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (soldOutMessage) {
                this.submitButton.setAttribute(
                  'aria-disabled',
                  true
                );

                if (this.submitButtonText) {
                  this.submitButtonText.classList.add(
                    'hidden'
                  );
                }

                soldOutMessage.classList.remove('hidden');
              }

              this.error = true;

              return;
            }

            /*
            --------------------------------
            SUCCESS
            --------------------------------

            Product has successfully been
            added to Shopify cart.

            Skip cart / mini-cart and go
            directly to checkout.
            */

            this.error = false;

            window.location.href = '/checkout';
          })

          .catch((error) => {
            console.error(
              'Error adding product to cart:',
              error
            );

            this.handleErrorMessage(
              'Something went wrong. Please try again.'
            );

            this.error = true;
          })

          .finally(() => {
            /*
            If we're redirecting successfully,
            this won't really matter.

            This is mainly here so the button
            resets if an error occurs.
            */

            if (!this.error) return;

            this.submitButton.classList.remove('loading');

            this.submitButton.removeAttribute(
              'aria-disabled'
            );
          });
      }

      /*
      --------------------------------
      REQUIRED FIELD VALIDATION
      --------------------------------
      */

      blockSubmitIfRequiredFieldsEmpty(event) {
        if (!(this.form instanceof HTMLFormElement)) {
          throw new Error(
            'Expected a form element.'
          );
        }

        const formId =
          this.form.getAttribute('id');

        const requiredFields =
          document.querySelectorAll('[required]');

        let allFilled = true;

        for (const field of requiredFields) {
          const belongsToForm =
            field.getAttribute('form') === formId ||
            field.closest('form')?.id === formId;

          if (!belongsToForm) continue;

          let isValid = true;

          switch (field.type) {
            case 'checkbox':
            case 'radio': {
              const group =
                document.querySelectorAll(
                  `input[name="${field.name}"][type="${field.type}"]`
                );

              const isChecked =
                Array.from(group).some(
                  (input) => input.checked
                );

              isValid = isChecked;

              break;
            }

            case 'select-one':
              isValid = field.value !== '';
              break;

            case 'textarea':
            case 'text':
            case 'email':
            case 'number':
            case 'url':
            default:
              isValid =
                String(field.value).trim() !== '';
              break;
          }

          if (!isValid) {
            allFilled = false;

            field.classList.add('invalid');
          } else {
            field.classList.remove('invalid');
          }
        }

        if (!allFilled) {
          event.preventDefault();

          this.handleErrorMessage(
            theme.accessibilityStrings
              .fillInAllLineItemPropertyRequiredFields
          );

          return false;
        }

        return true;
      }

      /*
      --------------------------------
      ERROR MESSAGE
      --------------------------------
      */

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      /*
      --------------------------------
      ENABLE / DISABLE ADD TO CART
      --------------------------------
      */

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (
            text &&
            this.submitButtonText
          ) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              theme.variantStrings.addToCart;
          }
        }
      }

      /*
      --------------------------------
      CURRENT VARIANT INPUT
      --------------------------------
      */

      get variantIdInput() {
        return this.form?.querySelector(
          '[name="id"]'
        );
      }
    }
  );
}